import { render, staticRenderFns } from "./FormGetPaymentMethod.vue?vue&type=template&id=b6155f60&scoped=true&"
import script from "./FormGetPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./FormGetPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./FormGetPaymentMethod.vue?vue&type=style&index=0&id=b6155f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6155f60",
  null
  
)

export default component.exports